// extracted by css-extract-rspack-plugin
export default {"container":"t9wjWQyFCb0HUoN2","support":"jKdG8CMKnnoHLfdU"};